import {ActionContext, ActionTree, GetterTree, Module, MutationTree} from "vuex";
import Receiver from "@/domain/receiver/Receiver";
import api from "@/api/backend-api";

export class ReceiverState {
  public receivers: Array<Receiver>;
  public minimumGiftCount: number;
  public maximumGiftCount: number;
  public message: string;

  constructor() {
    this.receivers = [];
    this.minimumGiftCount = 1;
    this.maximumGiftCount = 100;
    this.message = '';
  }
}

const getters: GetterTree<ReceiverState, any> = {
  hasReceiver(state: ReceiverState): boolean {
    return state.receivers.length > 0;
  },
  sumOfGiftCount(state: ReceiverState): number {
    return state.receivers.map((receiver: Receiver) => receiver.ticketCount)
                          .reduce((sum: number, val: number) => {
                            return sum + val;
                          }, 0);
  },
  isDecreasable: (state: ReceiverState) => (index: number) => {
    return state.receivers[index].ticketCount > state.minimumGiftCount;
  },
  isIncreasable: (state: ReceiverState) => (index: number) => {
    return state.receivers[index].ticketCount < state.maximumGiftCount;
  },
};

const mutations: MutationTree<ReceiverState> = {
  addReceiver(state: ReceiverState, receiver: Receiver): void {
    state.receivers.push(new Receiver(receiver));
  },
  removeReceiver(state: ReceiverState, index: number): void {
    state.receivers.splice(index, 1);
  },
  clearReceiverList(state: ReceiverState): void {
    state.receivers.splice(0, state.receivers.length);
  },
  increaseGiftCount(state: ReceiverState, index: number): void {
    state.receivers[index].ticketCount += 1;
  },
  decreaseGiftCount(state: ReceiverState, index: number): void {
    state.receivers[index].ticketCount -= 1;
  },
  setMaximumGiftCount(state: ReceiverState, maximumGiftCount: number): void {
    state.maximumGiftCount = maximumGiftCount;
  },
  setMessage(state: ReceiverState, message: string): void {
    state.message = message;
  },
  initReceiverStore(state: ReceiverState): void {
    state.receivers = [];
    state.minimumGiftCount = 1;
    state.maximumGiftCount = 100;
    state.message = '';
  }
};

const actions: ActionTree<ReceiverState, any> = {
  sendToMe(context: ActionContext<ReceiverState, any>) {
    context.commit('clearReceiverList');
    context.commit('addReceiver', new Receiver({
      receiverName: "나에게 선물",
      receiverTelNo: "",
      ticketCount: 1
    }));
  },
  fetchMaximumGiftCount(context: ActionContext<ReceiverState, any>, productId: number) {
    api.getGiftLimit(Number(productId)).then(response => {
      context.commit('setMaximumGiftCount', response.data.result.giftLimitCount);
    })
    .catch(error => {
      console.log("Error: " + error);
    });
  }
};

export const ReceiverStore: Module<ReceiverState, any> = {
  namespaced: true,
  state: new ReceiverState(),
  getters,
  mutations,
  actions
};